export default "/images/vendor/flag-icons/flags/4x3/nl.svg?cfe72ae0b3d6d848523400f70f59efe7";